const ms = {
    nav: {
      home: "Laman Utama",
      browse: "Layari Perkahwinan",
      dashboard: "Papan Pemuka",
      messages: "Mesej",
      profile: "Profil",
      login: "Log Masuk",
      register: "Daftar",
      logout: "Log Keluar",
      admin: "Pentadbir",
      faq: "Soalan Lazim",
      about: "Tentang Kami",
      contact: "Hubungi",
      pricing: "Harga",
      howItWorks: "Cara Ia Berfungsi",
    },
    auth: {
      login: {
        title: "Selamat Kembali",
        email: "Emel",
        password: "Kata Laluan",
        button: "Log Masuk",
        noAccount: "Tiada akaun?",
        register: "Daftar sekarang",
      },
      register: {
        title: "Cipta Akaun",
        name: "Nama Penuh",
        email: "Emel",
        password: "Kata Laluan",
        role: "Saya mahu...",
        roleHost: "Menganjurkan perkahwinan",
        roleGuest: "Menghadiri perkahwinan",
        terms: "Saya menerima terma dan dasar privasi",
        button: "Daftar",
        hasAccount: "Sudah ada akaun?",
        login: "Log masuk sekarang",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "Memuatkan...",
      error: "Ralat berlaku",
      success: "Berjaya",
      save: "Simpan",
      cancel: "Batal",
      delete: "Padam",
      edit: "Edit",
      back: "Kembali",
      next: "Seterusnya",
      language: "Bahasa",
      currency: "Mata Wang",
      search: "Cari",
      filter: "Tapis",
      all: "Semua",
      none: "Tiada",
      yes: "Ya",
      no: "Tidak",
    },
    footer: {
      about: "Tentang",
      privacy: "Privasi",
      terms: "Terma",
      contact: "Hubungi",
      copyright: "© 2024 WEDVAYA. Hak cipta terpelihara.",
    },
  };

export default ms;
